// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
import "@fontsource/permanent-marker"
import "@fontsource/reenie-beanie"
import "@fontsource/mynerve"
import "@fontsource/rock-salt"
import "@fontsource/redacted-script"
import "@fontsource/amatic-sc/400.css"
import "@fontsource/amatic-sc/700.css"
import "@fontsource/roboto-mono/300.css"
import "@fontsource/roboto-mono/400.css"
import "@fontsource/roboto-mono/700.css"
// normalize CSS across browsers
import "./src/normalize.css"
// bootstrap CSS style
import 'bootstrap/dist/css/bootstrap.min.css';
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

import { syncThemeColorForPath } from "./src/utils/themeColor"

const setViewportUnit = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

export const onClientEntry = () => {
  setViewportUnit()
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', setViewportUnit, { passive: true })
    window.addEventListener('orientationchange', setViewportUnit, { passive: true })
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setViewportUnit)
    }
    
    // Dynamically toggle has-touch class based on interaction type (touch vs mouse)
    const disableHover = () => {
      document.documentElement.classList.add('has-touch')
    }
    
    const enableHover = (e) => {
      if (e.pointerType === 'mouse') {
        document.documentElement.classList.remove('has-touch')
      }
    }
    
    window.addEventListener('touchstart', disableHover, { passive: true })
    window.addEventListener('pointermove', enableHover, { passive: true })
  }
}

const resetScrollPosition = () => {
  if (typeof window === 'undefined') return

  document.documentElement.style.scrollBehavior = 'auto'
  document.body.style.scrollBehavior = 'auto'
  window.history.scrollRestoration = 'manual'
  window.scrollTo(0, 0)
  window.requestAnimationFrame(() => window.scrollTo(0, 0))
  setTimeout(() => window.scrollTo(0, 0), 50)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

export const onInitialClientRender = () => {
  setViewportUnit()
  resetScrollPosition()
  if (typeof window !== "undefined") {
    syncThemeColorForPath(window.location.pathname)
  }
}

export const onPreRouteUpdate = () => {
  if (typeof window === 'undefined') return
  document.documentElement.style.scrollBehavior = 'auto'
  document.body.style.scrollBehavior = 'auto'
  window.scrollTo(0, 0)
}

export const onRouteUpdate = ({ location }) => {
  resetScrollPosition()
  if (!location?.pathname) return
  syncThemeColorForPath(location.pathname)
}

export const onRouteUpdateDelayed = ({ location }) => {
  if (!location?.pathname) return
  syncThemeColorForPath(location.pathname)
  requestAnimationFrame(() => syncThemeColorForPath(location.pathname))
}

export const shouldUpdateScroll = () => {
  if (typeof window === 'undefined') {
    return false
  }

  window.history.scrollRestoration = 'manual'
  return false
}

// In standalone (installed app) mode, navigate internal target="_blank" links in-app
if (typeof window !== "undefined") {
  window.addEventListener("click", (e) => {
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (!isStandalone) return;
    
    const anchor = e.target.closest("a");
    if (anchor && anchor.getAttribute("target") === "_blank") {
      const href = anchor.getAttribute("href");
      if (href && (href.startsWith("/") || href.startsWith(window.location.origin))) {
        e.preventDefault();
        window.location.href = href;
      }
    }
  });
}

